import React from 'react';
import { cn } from '../../lib/utils';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'active' | 'disabled' | 'archived' | 'neutral' | 'primary' | 'info';
  size?: 'sm' | 'md';
}

export const Badge: React.FC<BadgeProps> = ({ className, variant = 'neutral', size = 'sm', children, ...props }) => {
  const variants = {
    active: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30',
    disabled: 'bg-amber-500/15 text-amber-400 border-amber-500/30',
    archived: 'bg-slate-700/30 text-slate-400 border-slate-700/50',
    neutral: 'bg-slate-800 text-slate-300 border-slate-700/60',
    primary: 'bg-orange-500/15 text-orange-400 border-orange-500/30',
    info: 'bg-sky-500/15 text-sky-400 border-sky-500/30',
  };

  const sizes = {
    sm: 'px-2.5 py-0.5 text-xs',
    md: 'px-3 py-1 text-xs',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 font-medium rounded-full border select-none',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      <span
        className={cn(
          'w-1.5 h-1.5 rounded-full',
          variant === 'active' && 'bg-emerald-400',
          variant === 'disabled' && 'bg-amber-400',
          variant === 'archived' && 'bg-slate-400',
          variant === 'primary' && 'bg-orange-400',
          variant === 'info' && 'bg-sky-400',
          variant === 'neutral' && 'bg-slate-400'
        )}
      />
      {children}
    </span>
  );
};
